module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_faq ro.2833c258.svg";